import { Component } from '@angular/core';

@Component({
  selector: 'app-table-actions-button',
  templateUrl: './table-actions-button.component.html',
  standalone: false,
})
export class TableActionsButtonComponent {}
